import { useTranslation } from 'react-i18next';
import { HubContext, Submissions } from '../../types/hub';
import { SubmissionRow } from '../hub/SubmissionRow';

interface SubmissionListHeaderProps {
  hub: HubContext;
  submissions: Submissions;
  onSelectQuote: (quoteId: string) => void;
  expanded: boolean;
}

export default function SubmissionListHeader({
  hub,
  submissions,
  onSelectQuote,
}: SubmissionListHeaderProps) {
  const { t } = useTranslation('hub');
  const firstSubmission = submissions[0];

  if (!firstSubmission) return null;

  return (
    <div className="mt-4">
      {/* DESKTOP HEADER */}
      <div className="hidden md:block mt-4">
        <div className="grid grid-cols-6 text-sm text-gray-500 pb-1 border-b border-gray-400">
          <span>{t('contacts')}</span>
          <span>{t('submission_type_title')}</span>
          <span>{t('offer')}</span>
          <span>{t('received_date')}</span>
          <span>{t('team')}</span>
          <span></span>
        </div>

        <SubmissionRow item={firstSubmission} hub={hub} onSelectQuote={onSelectQuote} />
      </div>

      {/* MOBILE EMPTY HEADER */}
      <div className="block md:hidden h-1" />
    </div>
  );
}
